// src/components/PlacementGrid.jsx

import { motion } from "framer-motion";
import PlacementCard from "./PlacementCard";

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16,
  },

  visible: {
    opacity: 1,
    y: 0,
  },
};

const PlacementGrid = ({
  students = [],
  featuredLayout = false,
}) => {
  if (!students.length) {
    return null;
  }

  /* =========================================================
     KEEP FEATURED STUDENT FIRST
  ========================================================== */

  const orderedStudents = [...students].sort(
    (a, b) => {
      if (a.featured && !b.featured) return -1;
      if (!a.featured && b.featured) return 1;
      return 0;
    }
  );

  /* =========================================================
     FEATURED LAYOUT
  ========================================================== */

  if (featuredLayout) {
    const [
      featuredStudent,
      ...otherStudents
    ] = orderedStudents;

    return (
      <div
        className="
          grid
          grid-cols-1
          gap-4
          md:grid-cols-2
          lg:grid-cols-12
          lg:gap-5
        "
      >
        {/* Featured */}

        <motion.div
          variants={itemVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.12,
          }}
          transition={{
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="
            h-full
            md:col-span-2
            lg:col-span-5
          "
        >
          <PlacementCard
            student={featuredStudent}
            featured
          />
        </motion.div>

        {/* Supporting cards */}

        <div
          className="
            grid
            grid-cols-1
            gap-4
            sm:grid-cols-2
            md:col-span-2
            lg:col-span-7
            lg:gap-5
          "
        >
          {otherStudents
            .slice(0, 4)
            .map((student, index) => (
              <motion.div
                key={student.id}
                variants={itemVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{
                  once: true,
                  amount: 0.1,
                }}
                transition={{
                  duration: 0.42,
                  delay: index * 0.06,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="h-full"
              >
                <PlacementCard
                  student={student}
                />
              </motion.div>
            ))}
        </div>
      </div>
    );
  }

  /* =========================================================
     FULL CATALOGUE
  ========================================================== */

  return (
    <div
      className="
        grid
        grid-cols-1
        gap-4
        sm:grid-cols-2
        lg:grid-cols-3
        lg:gap-5
      "
    >
      {orderedStudents.map(
        (student, index) => (
          <motion.div
            key={student.id}
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.08,
            }}
            transition={{
              duration: 0.42,
              delay: Math.min(
                index * 0.045,
                0.22
              ),
              ease: [0.22, 1, 0.36, 1],
            }}
            className="h-full"
          >
            <PlacementCard
              student={student}
            />
          </motion.div>
        )
      )}
    </div>
  );
};

export default PlacementGrid;